import React, { ReactComponentElement } from 'react';
import { ReactComponent as Apple } from '../../../../media/apple.svg';
import styles from './Carer.module.css';

const CarerTypeUnavailableView = (): ReactComponentElement<any> => {
  return (
    <>
      <div className={styles.carerUnavailableContainer}>
        <Apple></Apple>
        <div className={styles.carerUnavailableTextContainer}>
          <label className={styles.carerUnavailableTextTitle}>
            Sorry, no slots available
          </label>
          <label className={styles.carerUnavailableTextBody}>
            New slots will appear here when they become available.
          </label>
        </div>
      </div>
    </>
  );
};

export default CarerTypeUnavailableView;
